<template>
  <div
    class="result-item user"
    @click="goToUserInfo(user.id)"
  >
    <user-photo
      :user="user"
      class="user-photo"
    />
    <div class="item-info">
      <span class="name">{{ user.firstName }} {{ user.lastName }}</span>
      <span>{{ user.department }}</span>
      <span>{{ userBusinessAndLocation }}</span>
    </div>
  </div>
</template>
<script>
import UserPhoto from '@/components/shared/UserPhoto'
import Utils from '../../utils'

export default {
  name: 'SearchResultUserItem',
  components: { UserPhoto },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUserInfo(userId) {
      this.$router.push({ name: 'userInfo', params: { id: userId } })
    }
  },
  computed: {
    userBusinessAndLocation() {
      return [this.user.businessLine, this.user.location].filter(Utils.isNotBlank).join(' | ')
    }
  }
}
</script>

<style lang="scss" scoped>
.result-item {
  display: flex;
  padding: 15px 0;

  &.post {
    align-items: flex-start;
  }

  &.user {
    align-items: center;
  }

  cursor: pointer;

  .user-photo {
    height: 48px;
    border-radius: 100%;
    margin-right: 15px;
  }

  .item-info {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: $black-color;
    font-size: 15px;
    margin-left: 10px;

    .name {
      font-weight: 700;
      color: $primary-color;
      font-size: 16px;
    }
  }
}
</style>
